// ============ اللغات والروابط (ملف بسيط من غير React: بيستخدمه الموقع وسكريبت الـ SEO) ============
// الإنجليزي على الرابط الأساسي (/about-us) وكل لغة تانية ليها بادئة (/ar/about-us, /ru/about-us, /it/..., /he/..., /zh/...)
import { SITE_URL } from "../Data/Company";

export const LANGUAGES = [
  { code: "en", label: "English", short: "EN", dir: "ltr", locale: "en-US", og: "en_US" },
  { code: "ar", label: "العربية", short: "AR", dir: "rtl", locale: "ar-EG", og: "ar_AE" },
  { code: "ru", label: "Русский", short: "RU", dir: "ltr", locale: "ru-RU", og: "ru_RU" },
  { code: "de", label: "Deutsch", short: "DE", dir: "ltr", locale: "de-DE", og: "de_DE" },
  { code: "fr", label: "Français", short: "FR", dir: "ltr", locale: "fr-FR", og: "fr_FR" },
  { code: "es", label: "Español", short: "ES", dir: "ltr", locale: "es-ES", og: "es_ES" },
  { code: "it", label: "Italiano", short: "IT", dir: "ltr", locale: "it-IT", og: "it_IT" },
  { code: "he", label: "עברית", short: "HE", dir: "rtl", locale: "he-IL", og: "he_IL" },
  { code: "zh", label: "简体中文", short: "中文", dir: "ltr", locale: "zh-CN", og: "zh_CN", hreflang: "zh-Hans" },
];

export const DEFAULT_LANG = "en";
export const CODES = LANGUAGES.map((l) => l.code);

export const getLanguage = (code) => LANGUAGES.find((l) => l.code === code) || LANGUAGES[0];

// اللغة من أول جزء في الرابط
export const langFromPath = (path = "/") => {
  const seg = String(path).split("/")[1];
  return CODES.includes(seg) && seg !== DEFAULT_LANG ? seg : DEFAULT_LANG;
};

// الرابط من غير بادئة اللغة: /ar/about-us => /about-us
export const stripLang = (path = "/") => {
  const lang = langFromPath(path);
  if (lang === DEFAULT_LANG) return path || "/";
  const rest = String(path).slice(lang.length + 1);
  return rest.startsWith("/") ? rest : `/${rest}`;
};

// نفس الصفحة بلغة تانية: pathFor("ar", "/about-us") => /ar/about-us
export const pathFor = (code, path = "/") => {
  const clean = stripLang(path);
  if (code === DEFAULT_LANG) return clean;
  return `/${code}${clean === "/" ? "" : clean}`;
};

// الرابط الكامل للصفحة (canonical / hreflang / sitemap)
export const absUrl = (code, path = "/") => {
  const p = pathFor(code, path);
  return `${SITE_URL}${p === "/" ? "/" : p}`;
};

// خطوط إضافية لبعض اللغات (الخط الأساسي Italiana + Jost موجود في index.html)
export const FONT_HREF = {
  ar: "https://fonts.googleapis.com/css2?family=Alexandria:wght@200;300;400;500&family=IBM+Plex+Sans+Arabic:wght@300;400;500;600&display=swap",
  ru: "https://fonts.googleapis.com/css2?family=Forum&display=swap",
  he: "https://fonts.googleapis.com/css2?family=Frank+Ruhl+Libre:wght@300;400;500&family=Heebo:wght@300;400;500&display=swap",
  zh: "https://fonts.googleapis.com/css2?family=Noto+Sans+SC:wght@300;400;500&family=Noto+Serif+SC:wght@300;400;500&display=swap",
};
